import { z } from 'zod';
import { optionalText, text, uuidSchema } from './common.js';
/**
 * A non-leaseholder occupant or a pet on file for a tenant. See the
 * `Dependent`/`Pet` doc comments in schema.prisma for why relationship/
 * species are free text rather than a fixed enum, and why these are
 * staff-only for now.
 */
export const createDependentSchema = z.object({
    tenantId: uuidSchema,
    name: text(200),
    relationship: text(100),
    notes: optionalText(2000),
});
export const updateDependentSchema = createDependentSchema.omit({ tenantId: true }).partial();
export const createPetSchema = z.object({
    tenantId: uuidSchema,
    name: text(200),
    species: text(100),
    breed: optionalText(100),
    notes: optionalText(2000),
});
export const updatePetSchema = createPetSchema.omit({ tenantId: true }).partial();
//# sourceMappingURL=household.js.map